import { ErrorBoundary } from "@components/index";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
export const GlobalLayout = () => {
  return (
    <ErrorBoundary>
      <Layout>
        <Outlet />
      </Layout>
    </ErrorBoundary>
  );
};
